<script setup lang="ts">
import type { IFeatureItem, IFeatures } from '@/models'
import FeatureList from './children/FeatureList.component.vue'
import LargeImageDialog from './children/LargeImageDialog.vue'
interface TProps {
  lcid: string
  features: IFeatures
}
const props = defineProps<TProps>()
const { translate } = useLocalization()
// retrieve page data passed down from layouts:
const features: IFeatures = props.features

const _state = reactive({
  dialogTitle: 'Screenshot',
  imageSrc: '',
  imageAlt: '',
  showLargeImageDialog: false,
})

const handleCloseDialog = () => {
  _state.showLargeImageDialog = false
}

const handleViewLargeImage = (item: IFeatureItem) => {
  //_state.dialogTitle = item.header || ''
  _state.imageAlt = item.header || 'Screenshot'
  _state.imageSrc = item.imageSrc!
  _state.showLargeImageDialog = true
}
</script>

<template>
  <div id="securityfirst" class="bg-card content-card bg-opacity-80 opacity-90 py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="mx-auto max-w-2xl mb-16 lg:mx-0">
        <h2 class="text-3xl font-bold tracking-tight sm:text-4xl">
          {{ features?.title }}
        </h2>
        <p v-if="features?.subtitle" class="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">
          {{ features?.subtitle }}
        </p>
        <p class="mt-6 text-lg leading-8 opacity-80">
          {{ features?.summary }}
        </p>
      </div>

      <div class="mx-auto max-w-2xl lg:max-w-none">
        <FeatureList :items="features?.items" @viewLargeImage="handleViewLargeImage" />
      </div>

      <div class="mt-16 mx-auto max-w-2xl lg:max-w-none">
        <a href="#featurelist" class="text-primary hover:text-primary text-sm font-semibold leading-6">
          {{ translate('navigation.more') }} <span aria-hidden="true">→</span>
        </a>
      </div>
    </div>
  </div>
  <ClientOnly>
    <LargeImageDialog
      v-if="_state.showLargeImageDialog"
      :lcid="lcid"
      :title="_state.dialogTitle"
      :imageSrc="_state.imageSrc"
      :imageAlt="_state.imageAlt"
      @close="handleCloseDialog"
    />
  </ClientOnly>
</template>
